import { select as d } from "d3";
import { a as P, c as A, r as $, g as v, d as H, e as L } from "./color-scale-utils-38aedd61.mjs";
import { _ as D, T as p, o as E } from "./enums-a96ef472.mjs";
var W = /\s/;
function q(s) {
  for (var e = s.length; e-- && W.test(s.charAt(e)); )
    ;
  return e;
}
var _ = /^\s+/;
function j(s) {
  return s && s.slice(0, q(s) + 1).replace(_, "");
}
var N = 0 / 0, U = /^[-+]0x[0-9a-f]+$/i, J = /^0b[01]+$/i, X = /^0o[0-7]+$/i, Y = parseInt;
function O(s) {
  if (typeof s == "number")
    return s;
  if (P(s))
    return N;
  if (A(s)) {
    var e = typeof s.valueOf == "function" ? s.valueOf() : s;
    s = A(e) ? e + "" : e;
  }
  if (typeof s != "string")
    return s === 0 ? s : +s;
  s = j(s);
  var t = J.test(s);
  return t || X.test(s) ? Y(s.slice(2), t ? 2 : 8) : U.test(s) ? N : +s;
}
var Z = function() {
  return $.Date.now();
};
const T = Z;
var Q = "Expected a function", K = Math.max, ee = Math.min;
function te(s, e, t) {
  var n, i, a, r, l, h, f = 0, y = !1, u = !1, c = !0;
  if (typeof s != "function")
    throw new TypeError(Q);
  e = O(e) || 0, A(t) && (y = !!t.leading, u = "maxWait" in t, a = u ? K(O(t.maxWait) || 0, e) : a, c = "trailing" in t ? !!t.trailing : c);
  function m(o) {
    var g = n, b = i;
    return n = i = void 0, f = o, r = s.apply(b, g), r;
  }
  function S(o) {
    return f = o, l = setTimeout(C, e), y ? m(o) : r;
  }
  function I(o) {
    var g = o - h, b = o - f, F = e - g;
    return u ? ee(F, a - b) : F;
  }
  function M(o) {
    var g = o - h, b = o - f;
    return h === void 0 || g >= e || g < 0 || u && b >= a;
  }
  function C() {
    var o = T();
    if (M(o))
      return R(o);
    l = setTimeout(C, I(o));
  }
  function R(o) {
    return l = void 0, c && n ? m(o) : (n = i = void 0, r);
  }
  function k() {
    l !== void 0 && clearTimeout(l), f = 0, n = h = i = l = void 0;
  }
  function V() {
    return l === void 0 ? r : R(T());
  }
  function w() {
    var o = T(), g = M(o);
    if (n = arguments, i = this, h = o, g) {
      if (l === void 0)
        return S(h);
      if (u)
        return clearTimeout(l), l = setTimeout(C, e), m(h);
    }
    return l === void 0 && (l = setTimeout(C, e)), r;
  }
  return w.cancel = k, w.flush = V, w;
}
class G {
  constructor(e, t) {
    this.model = e, this.services = t, this.init();
  }
  init() {
  }
  update() {
  }
  // Used to pass down information to the components
  setModel(e) {
    this.model = e;
  }
  // Used to pass down services to the components
  setServices(e) {
    this.services = e;
  }
}
const ne = "DONT_STYLE_ME_css_styles_verifier";
class B extends G {
  // initialized in initializeID() called by init()
  constructor(e, t) {
    super(e, t), this.chartID = "";
  }
  static getHTMLElementSize(e) {
    return {
      width: e.clientWidth,
      height: e.clientHeight
    };
  }
  static getSVGElementSize(e, t = {
    useAttrs: !1,
    useClientDimensions: !1,
    useBBox: !1,
    useBoundingRect: !1
  }) {
    e.attr || (e = d(e));
    const n = {
      width: 0,
      height: 0
    }, i = (c) => {
      c && Object.keys(n).forEach((m) => {
        if (c[m]) {
          const S = c[m], I = parseFloat(S);
          S && I > n[m] && ("" + S).indexOf("%") === -1 && (n[m] = I);
        }
      });
    }, a = {
      width: e.attr("width"),
      height: e.attr("height")
    }, r = e.node();
    let l, h, f, y;
    try {
      typeof r.getBBox == "function" && (l = r.getBBox(), h = {
        width: l.width,
        height: l.height
      });
    } catch (c) {
      console.error(c);
    }
    try {
      typeof (r == null ? void 0 : r.getBoundingClientRect) == "function" && (f = r.getBoundingClientRect(), y = {
        width: f.width,
        height: f.height
      });
    } catch (c) {
      console.error(c);
    }
    let u;
    if (r instanceof SVGSVGElement && (u = {
      width: r.clientWidth,
      height: r.clientHeight
    }), t) {
      if (t.useAttrs && (i(a), n.width > 0 && n.height > 0))
        return n;
      if (t.useClientDimensions && (i(u), n.width > 0 && n.height > 0))
        return u;
      if (t.useBBox && (i(h), n.width > 0 && n.height > 0))
        return h;
      if (t.useBoundingRect && (i(y), n.width > 0 && n.height > 0))
        return y;
    }
    try {
      const c = {
        width: v(e.node(), "width", "baseVal", "value"),
        height: v(e.node(), "height", "baseVal", "value")
      };
      i(c);
    } catch {
      i(u), i(h), i(a);
    }
    return n;
  }
  static appendOrSelect(e, t) {
    const n = e.select(`${t}`);
    if (n.empty()) {
      let i = t.split("#"), a, r;
      return i.length === 2 ? (a = i[0], i = i[1].split("."), r = i[0]) : (i = t.split("."), a = i[0]), e.append(a).attr("id", r).attr("class", i.slice(1).join(" "));
    }
    return n;
  }
  init() {
    this.styleHolderElement(), this.initializeID(), this.addMainContainer(), this.model.getOptions().resizable && this.addResizeListener(), this.addHolderListeners(), this.handleFullscreenChange();
  }
  getChartID() {
    return this.chartID;
  }
  generateElementIDString(e) {
    return `chart-${this.chartID}-${e}`;
  }
  initializeID() {
    this.chartID = Math.floor((1 + Math.random()) * 281474976710656).toString(16);
  }
  addMainContainer() {
    const e = this.model.getOptions(), t = v(e, "style", "prefix"), n = d(this.getHolder()).append("div").classed(`${H}--${t}--chart-wrapper`, !0).attr("id", `chart-${this.getChartID()}`).style("height", "100%").style("width", "100%");
    n.append("g").attr("class", ne), this.mainContainer = n.node();
  }
  update() {
    this.styleHolderElement();
  }
  styleHolderElement() {
    const e = this.getHolder(), { width: t, height: n, theme: i } = this.model.getOptions();
    t !== this.width && (e.style.width = t, this.width = t), n !== this.height && (e.style.height = n, this.height = n), d(this.getHolder()).classed(`${H}--chart-holder`, !0).attr("data-carbon-theme", i);
  }
  getHolder() {
    return this.model.get("holder");
  }
  exportToJPG() {
    const e = this, t = this.getHolder(), n = d(t);
    n.classed("filled", !0), L.toJpeg(this.getMainContainer(), {
      bgcolor: typeof window < "u" ? window.getComputedStyle(t).getPropertyValue("background-color") : void 0,
      quality: 1,
      // Remove the toolbar
      filter: (i) => !(i.classList && i.classList.contains("cds--cc--toolbar"))
    }).then(function(i) {
      var a;
      (a = e.services.files) == null || a.downloadImage(i, "myChart.jpg"), n.classed("filled", !1);
    });
  }
  exportToPNG() {
    const e = this, t = this.getHolder(), n = d(t);
    n.classed("filled", !0), L.toPng(this.getMainContainer(), {
      bgcolor: typeof window < "u" ? window.getComputedStyle(t).getPropertyValue("background-color") : void 0,
      quality: 1,
      // Remove the toolbar
      filter: (i) => !(i.classList && i.classList.contains("cds--cc--toolbar"))
    }).then(function(i) {
      var a;
      (a = e.services.files) == null || a.downloadImage(i, "myChart.png"), n.classed("filled", !1);
    }).catch(function(i) {
      console.error("oops, something went wrong!", i);
    });
  }
  toggleFullscreen() {
    const e = this.getHolder();
    d(e).classed("fullscreen") && (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) ? document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen() : e.requestFullscreen ? e.requestFullscreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.msRequestFullscreen && e.msRequestFullscreen();
  }
  handleFullscreenChange() {
    document.addEventListener("fullscreenchange", () => {
      const e = d(this.getHolder()), t = e.classed("fullscreen");
      e.classed("fullscreen", !t);
    });
  }
  setSVGMaxHeight() {
    if (!this.model.getOptions().height) {
      const { height: e } = B.getSVGElementSize(
        d(this.mainContainer),
        {
          useBBox: !0
        }
      ), t = d(this.mainContainer).attr("class"), n = d(this.mainContainer).selectAll(`.${t} > svg`);
      let i = 0;
      n.nodes().forEach(function(a) {
        i += Number(
          B.getSVGElementSize(d(a), {
            useBBox: !0
          }).height
        );
      }), i <= e ? d(this.mainContainer).attr("height", i) : d(this.mainContainer).attr("height", "100%");
    }
  }
  getMainContainer() {
    return this.mainContainer;
  }
  addHolderListeners() {
    const e = this.getHolder();
    e && d(e).on("mouseover", () => {
      var t;
      (t = this.services.events) == null || t.dispatchEvent(D.Chart.MOUSEOVER);
    }).on("mouseout", () => {
      var t;
      (t = this.services.events) == null || t.dispatchEvent(D.Chart.MOUSEOUT);
    });
  }
  addResizeListener() {
    const e = this.getHolder();
    if (!e)
      return;
    let t = e.clientWidth, n = e.clientHeight;
    const i = te(() => {
      var r;
      e && (Math.abs(t - e.clientWidth) > 1 || Math.abs(n - e.clientHeight) > 1) && (t = e.clientWidth, n = e.clientHeight, (r = this.services.events) == null || r.dispatchEvent(D.Chart.RESIZE));
    }, 12.5);
    new ResizeObserver(i).observe(e);
  }
}
class z extends G {
  static appendOrUpdateLinearGradient(e) {
    let t = e.svg.select(`defs linearGradient#${e.id}`);
    t.empty() && (t = e.svg.append("defs").append("linearGradient").attr("id", e.id).attr("x1", e.x1).attr("x2", e.x2).attr("y1", e.y1).attr("y2", e.y2)), t.selectAll("stop").remove(), t.selectAll("stop").data(e.stops).enter().append("stop").attr("offset", (n) => n.offset).style("stop-color", (n) => n.color).style("stop-opacity", (n) => n.opacity);
  }
  static getOffsetRatio(e) {
    return (Math.abs(e[1]) * 100 / Math.abs(e[0] - e[1])).toFixed(2) + "%";
  }
  static getStops(e, t) {
    const n = e[0] < 0 && e[1] > 0;
    let i = [
      {
        offset: "0%",
        color: t,
        opacity: "0.6"
      },
      {
        offset: "80%",
        color: t,
        opacity: "0"
      }
    ];
    return n && (i = [
      {
        offset: "0%",
        color: t,
        opacity: "0.6"
      },
      {
        offset: z.getOffsetRatio(e),
        color: t,
        opacity: "0"
      },
      {
        offset: "100%",
        color: t,
        opacity: "0.6"
      }
    ]), i;
  }
}
function le(s) {
  const e = ie(se(s), 360);
  return x(e, [0, 10]) || x(e, [350, 0]) ? {
    textAnchor: p.START,
    dominantBaseline: E.MIDDLE
  } : x(e, [10, 80]) ? {
    textAnchor: p.START,
    dominantBaseline: E.HANGING
  } : x(e, [80, 100]) ? {
    textAnchor: p.MIDDLE,
    dominantBaseline: E.HANGING
  } : x(e, [100, 170]) ? {
    textAnchor: p.END,
    dominantBaseline: E.HANGING
  } : x(e, [170, 190]) ? {
    textAnchor: p.END,
    dominantBaseline: E.MIDDLE
  } : x(e, [190, 260]) ? {
    textAnchor: p.END,
    dominantBaseline: E.BASELINE
  } : x(e, [260, 280]) ? {
    textAnchor: p.MIDDLE,
    dominantBaseline: E.BASELINE
  } : {
    textAnchor: p.START,
    dominantBaseline: E.BASELINE
  };
}
function ie(s, e) {
  return (s % e + e) % e;
}
function x(s, [e, t]) {
  return s >= e && s <= t;
}
function se(s) {
  return s * (180 / Math.PI);
}
function ce(s) {
  return s * (Math.PI / 180);
}
function de(s, e, t = { x: 0, y: 0 }) {
  const n = e * Math.cos(s) + t.x, i = e * Math.sin(s) + t.y;
  return { x: isNaN(n) ? 0 : n, y: isNaN(i) ? 0 : i };
}
function he(s, e) {
  return e * Math.sin(s - Math.PI / 2);
}
export {
  B as D,
  z as G,
  G as S,
  he as a,
  se as b,
  te as c,
  ce as d,
  de as p,
  le as r,
  O as t
};
//# sourceMappingURL=angle-utils-a4fbf1b8.mjs.map
